const initialState = {
  header: false, // 'landing' || 'app' || false
  menuOpen: !!(window.screen && window.screen.width && window.screen.width > 800),
  headerTitle: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LAYOUT/SET_LAYOUT':
      return {
        ...initialState,
        ...{ menuOpen: state.menuOpen },
        ...action.payload,
      }
    case 'LAYOUT/TOGGLE_MENU':
      return {
        ...state,
        menuOpen: action.payload || !state.menuOpen,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Layout/Layout.reducer.js